import { Box, Typography } from "@mui/material";
import React from "react";
import useAuth from "../customHooks/useAuth";

const TopBarComponent = () => {
  const { u_name, company_name, role_id, department_name, job_role } = useAuth()
  const styles = {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItem: "center",
    position: "sticky",
    top: "0px",
    zIndex: 99,
    boxSadhow: "5px 0 10px black",
    p: 1,
  };
  return (
    <>

      <Box sx={styles} bgcolor={"white"} borderBottom={"2px lightgrey solid"}>
        <div>
          <Typography fontSize={"1.6em"} fontWeight="bold" color={"#08086b"}>
            Welcome to Magod Laser Machining Private Limited.
          </Typography>
        </div>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <Typography
            variant="body"
            fontSize={"1.2em"}
            color={"#08086b"}
            fontWeight={"bold"}
          >
            {u_name}
          </Typography>
          {/* <Typography
              variant="body"
              fontSize={"1.0em"}
              color={"#cf2e2e"}
              fontWeight={"bold"}
            >
              {role_id === 2000
                ? "Super Admin"
                : role_id === 3000
                  ? "Company Head"
                  : role_id === 4000
                    ? "Unit Head"
                    : role_id === 5000
                      ? "Employee"
                      : ""}
            </Typography> */}
          {/* {(job_role === "DAdmin" || job_role === "DUser") && (
              <Typography
                variant="body"
                fontSize={"1.1em"}
                color={"#1976D2"}
                fontWeight={"bold"}
              >
                {department_name}
              </Typography>
            )} */}

          {/* {(role_id === 3000) && (
              <Typography
                variant="body"
                fontSize={"1.1em"}
                color={"#08086b"}
                fontWeight={"bold"}
              >
                {company_name}
              </Typography>
            )} */}
          {job_role && (
            <Typography
              variant="body"
              fontSize={"1em"}
              color={"#08086b"}
            // fontWeight={"bold"}
            >
              {job_role}
            </Typography>
          )}
          {(role_id === 4000 || role_id === 6000) && (
            <Typography
              variant="body"
              fontSize={"1.1em"}
              color={"#08086b"}
              fontWeight={"bold"}
            >
              {department_name}
            </Typography>
          )}
        </Box>
      </Box>
    </>
  );
};

export default TopBarComponent;
